$(document).ready(function() {
  jQuery(".product-write-review").on('click',function(e) {
    $(".product-review").toggleClass("open-model");
    $('body').addClass('no-scroll open');
    $('.overlay').addClass('active');
  });
  $('body').on('click', '.overlay.active,.review-close-icon', function (e) {
    $(".product-review").removeClass("open-model");
    $('body').removeClass('no-scroll open');
    $('.overlay').removeClass('active');
  });
  jQuery('.cart__items-wrapper,.cart__footer-wrapper').wrapAll('<section class="cart-page-section padding-bottom"><div class="container"><div class="row"></div></div></div>');
  jQuery('.carthead').prependTo('.template-cart .wrapper > .container > .row');
  countDownIni('.flip-countdown,.js-flip-countdown');
  /*********  size Popup  ********/ 
      $(".size-btn").click(function() { 
        $(".size-popup").toggleClass("active"); 
        $("body").toggleClass("no-scroll");
    });
    $(".close-search").click(function() { 
        $(".size-popup").removeClass("active"); 
        $("body").removeClass("no-scroll");
    });
    $(".close-btn").click(function() { 
        $(".size-popup").removeClass("active"); 
        $("body").removeClass("no-scroll");
    });
    /********* On scroll heder Sticky *********/
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
            $("header").addClass("head-sticky");
        } else {
            $("header").removeClass("head-sticky");
        }
    });   
    /********* Mobile Menu ********/  
    $('#menu').on('click',function(e){
        e.preventDefault();
        setTimeout(function(){
            $('body').addClass('no-scroll active-menu');
            $(".mobile-menu-wrapper").toggleClass("active-menu");
            $('.overlay').addClass('menu-overlay');
        }, 50);
      $('.hmuser').removeClass('active');
      $('.hmuser').next().slideUp('fast');
          $(".product-review").removeClass("open-model");
    $('body').removeClass('no-scroll open');
    $('.overlay').removeClass('active');
    }); 
    
    $('body').on('click','.overlay, .overlay.menu-overlay, .menu-close-icon svg', function(e){
        e.preventDefault(); 
        $('body').removeClass('no-scroll active-menu');
        $(".mobile-menu-wrapper").removeClass("active-menu");
        $('.overlay').removeClass('menu-overlay');
        $(".product-review").removeClass("open-model");
    });
  
  /*-------------------- video -------------------*/
 $('.playbutton-sec').on('click', function(){
   $('body').addClass('popup-toggle'); 
    $('.video-popup').fadeIn('slow');
    return false;
  });
  
  $('.popup-bg').on('click', function(){
    $('body,html').removeClass('no-scroll popupopen');  
    $('body').removeClass('popup-toggle'); 
    $('.video-popup').fadeOut('slow');
    return false;
  });
  
   $('.close-btn').on('click', function(){
    $('body,html').removeClass('no-scroll popupopen');  
     $('body').removeClass('popup-toggle'); 
    $('.video-popup').fadeOut('slow');
    return false;
   });
    /********* Cart Popup ********/
    $('.main-cart').on('click', function (e) {
      $('body').addClass('no-scroll cartOpen open');
      $('.hmuser').removeClass('active');
      $('.hmuser').next().slideUp('fast');
      $(".product-review").removeClass("open-model");
      $('body').removeClass('no-scroll open');
      $('.overlay').removeClass('active');
    });
    $('body').on('click', '.overlay.cart-overlay, .closecart', function (e) {
      $('body').removeClass('no-scroll cartOpen open');
    });
    /********* Mobile Filter Popup ********/
    $('.mobile-facets__open').on('click', function (e) {
      $('body').addClass('mobile-open no-scroll');
      $('.overlay').addClass('active');
    });
    $('.overlay,.close-filter,.apply-btn').on('click', function (e) {
      $('body').removeClass('mobile-open no-scroll');
      $('.overlay').removeClass('active');
    });
    $('.filter-title').on('click',function(e){
        e.preventDefault();
        setTimeout(function(){
            $('body').addClass('no-scroll filter-open');
            $('.overlay').addClass('active');
        }, 50);
    }); 
    $('body').on('click','.overlay.active, .close-filter', function(e){
        e.preventDefault(); 
        $('.overlay').removeClass('active');
        $('body').removeClass('no-scroll filter-open');
    });
    /*********  Header Search Popup  ********/ 
    $(".search-header .header__icon--search").click(function() { 
        $(".search-popup").toggleClass("active"); 
        $("body").toggleClass("no-scroll");
        $('.hmuser').removeClass('active');
        $('.hmuser').next().slideUp('fast');
          $(".product-review").removeClass("open-model");
    $('body').removeClass('no-scroll open');
    $('.overlay').removeClass('active');
    });
    $(".close-search").click(function() { 
        $(".search-popup").removeClass("active"); 
        $("body").removeClass("no-scroll");
    });
      // User and Cart Toggle
    $(document).on('click', '.hmuser', function(e) {
        $(this).toggleClass('active');
        $(this).next().slideToggle('fast');
        $(".dropdown-menu").not($(this).next()).slideUp('fast');
    });
    /******* Cookie Js *******/
    $('.cookie-close').click(function () {
        $('.cookie').slideUp();
    });
    /******* Subscribe popup Js *******/
    $('.close-sub-btn').click(function () {
        $('.subscribe-popup').slideUp(); 
        $(".subscribe-overlay").removeClass("open");
    });      
    /********* qty spinner ********/
    var quantity = 0;
    $('.quantity-increment').click(function(){;
        var t = $(this).siblings('.quantity');
        var quantity = parseInt($(t).val());
        $(t).val(quantity + 1); 
    }); 
    $('.quantity-decrement').click(function(){
        var t = $(this).siblings('.quantity');
        var quantity = parseInt($(t).val());
        if(quantity > 1){
            $(t).val(quantity - 1);
        }
    });   
    /*********  Multi-level accordion nav  ********/ 
    $('.acnav-label').click(function () {

      
        var label = $(this);
        var parent = label.parent('.has-children');
        var list = label.siblings('.acnav-list');
        if (parent.hasClass('is-open')) {
            list.slideUp('fast');
            parent.removeClass('is-open');
        }
        else {
          //My Custom code
const collection = document.getElementsByClassName("acnav-label");
      
for (let i = 0; i < collection.length; i++) {
  var label2 = $(collection[i]);
   var parent2 = label2.parent('.has-children');
  if (parent2.hasClass('is-open')) {
  var list2 = label2.siblings('.acnav-list');
            list2.slideUp('fast');
    parent2.removeClass('is-open');
  }
}
      //Custom code ends here
          
            list.slideDown('fast');
            parent.addClass('is-open');
        }
    }); 
    /****  TAB Js ****/
    $('ul.tabs li').click(function(){ 
        var tab_id = $(this).attr('data-tab'); 
        $('ul.tabs li').removeClass('active');
        $('.tab-content').removeClass('active');  
        $(this).addClass('active');
        $("#"+tab_id).addClass('active');

      // $('.bestsell-slide').slick('refresh');

	}) 
    $('.hiro-image-slider').slick({ 
          arrows: false,
          dots: false,
          speed: 500,
          slidesToShow: 1,
          infinite: false,
          cssEase: 'ease-in-out',
          swipe: false,
          fade: true,
          slidesToScroll: 1,  
          asNavFor: '.hiro-side-slider, .hiro-thumb-slider'
      });
      $('.hiro-side-slider').slick({ 
        arrows: false,
        fade: true, 
        infinite: false, 
        speed: 500,
        swipe: false,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        slidesToScroll: 1,  
        adaptiveHeight: true,
        asNavFor: '.hiro-thumb-slider, .hiro-image-slider'
      });
      $('.hiro-thumb-slider').slick({ 
        arrows: false, 
        infinite: false,
        slidesToShow: 4,   
        slidesToScroll: 1,   
        asNavFor: '.hiro-side-slider, .hiro-image-slider',
        focusOnSelect: true,
      });
    $('.playbutton-sec').click(function (m) { 
        $('body,html').addClass('no-scroll popupopen');
        $('.overlay-popup').addClass('popup-show');
    });  
    $('.popup_close').click(function (m) { 
        $('body,html').removeClass('no-scroll popupopen');  
        $('.overlay-popup').removeClass('popup-show');
    });    
   
    /** PDP slider **/
    $('.two-coll-content .thmb-pro-main').slick({
        dots: false,
        infinite: true,
        speed:1000,
        loop: true,
        slidesToShow: 1,
        arrows: false,
        asNavFor: '.two-coll-content .thumb-pro-list',
    });
    $('.two-coll-content .thumb-pro-list').slick({
        arrows: false,
        asNavFor: '.two-coll-content .thmb-pro-main', 
        speed: 1000,
        dots: false,
        slidesToScroll: 1, 
        loop: true,
        infinite: true, 
        focusOnSelect: true,
        slidesToShow: 3
    });
      $('.pro-main-slider').slick({
        dots: false,
        infinite: true,
        speed:1000,
        loop: true,
        slidesToShow: 1,
        arrows: false,
        asNavFor: '.pdp-thumb-slider',
    });
    $('.pdp-thumb-slider').slick({
        prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
        nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
        dots: false,
        asNavFor: '.pro-main-slider', 
        speed: 1000, 
        slidesToScroll: 1,
        touchMove: true,
        focusOnSelect: true,
        loop: true,
        infinite: true,
        focusOnSelect: true,
        slidesToShow: 4,
        responsive: [{
                breakpoint: 1261,
                settings: {
                    slidesToShow: 3 
                }
            } 
        ]   
    }); 

  //New Slider
  $('.slider-nav').slick({
	pauseOnHover: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,arrows: false,
	autoplay: false,
    infinite: false, 
	autoplaySpeed:10000,
  focusOnSelect: true,
	dots: false,
    vertical: true,
	// appendDots: $('.slider-dots-box'),
	// dotsClass: 'slider-dots',
});
const slider = $(".slider-nav");


slider.on('wheel', (function(e) {
  e.preventDefault();

  if (e.originalEvent.deltaY < 0) {
    $(this).slick('slickNext');
  } else {
    $(this).slick('slickPrev');
  }
}));
  
// On before slide change
$('.slider-nav').on('beforeChange', function(event, slick, currentSlide, nextSlide){
  $('.slider-dots-box button').html('');
}).trigger('beforeChange');

// On before slide change
$('.slider-nav').on('afterChange', function(event, slick, currentSlide){
  $('.slider-dots-box button').html('');
	 $('.slider-dots-box .slick-active button')
		 .html(`<svg class="progress-svg" width="40" height="40">
		<g transform="translate(20,20)">
      <circle class="circle-go" r="19" cx="0" cy="0"></circle>
      <text class="circle-tx" x="0" y="4" alignment-baseline="middle" stroke-width="0" text-anchor="middle">${(currentSlide || 0) + 1}</text>
		</g>
    </svg>`);
}).trigger('afterChange');
     //Vix story Slider
 $('.slick-carousel').slick({
    arrows: false,
    centerPadding: "0px",
    dots: true,
   speed: 1900,
    slidesToShow: 1,
    infinite: false,
    vertical:true,verticalSwiping: true
  });
  const slider2 = $(".slick-carousel");
slider2.on('afterChange', onSliderAfterChange);
slider2.on('wheel', (function(e) {
  
  //  var deltaY = e.originalEvent.deltaY,
  //     $currentSlider = $(e.currentTarget),
  //     currentSlickIndex = $currentSlider.data('current-slide') || 0;
  // if(deltaY > 0 && currentSlickIndex == $currentSlider.data('slider-length') - 1)
  //   ) {
  //     return;
  //   }

var dataId = $(e.currentTarget).data('current-slide');
  // console.log(e.originalEvent.deltaY);
  if(dataId == 3 ){
    if(e.originalEvent.deltaY>0)return;
    $('html,body').scrollTop(0);
  }
    
  // console.log('111');
  e.preventDefault();
  if (e.originalEvent.deltaY < 0) {
    $(this).slick('slickPrev');
  } else {
    console.log(e.originalEvent.deltaY);
    $(this).slick('slickNext');
  }
}));
  function onSliderAfterChange(event, slick, currentSlide) {
     $(event.target).data('current-slide', currentSlide);
    // console.log(currentSlide);
  }
  //Vix aboutus Slider
 $('.aboutslick-carousel').slick({
    arrows: false,
    centerPadding: "0px",
    dots: false,
   speed: 1900,
    slidesToShow: 1,
    infinite: false,
    vertical:true,verticalSwiping: true
  });
  const slider3 = $(".aboutslick-carousel");
slider3.on('afterChange', onSliderAfterChange2);
slider3.on('wheel', (function(e) {
var dataId = $(e.currentTarget).data('current-slide');
  if(dataId == 3){if(e.originalEvent.deltaY>0)return;$('html,body').scrollTop(0);}
  
  e.preventDefault();
  if (e.originalEvent.deltaY < 0) {
    $(this).slick('slickPrev');
  } else {
    $(this).slick('slickNext');
  }
}));
  //Vix aboutus Slider 2
 $('.aboutslick2-carousel').slick({
    arrows: false,
    centerPadding: "0px",
    dots: true,
   speed: 1900,
    slidesToShow: 1,
    infinite: false,
    vertical:true,verticalSwiping: true
  });
  const slider3b = $(".aboutslick2-carousel");
slider3b.on('afterChange', onSliderAfterChange2);
slider3b.on('wheel', (function(e) {
var dataId = $(e.currentTarget).data('current-slide');
  if(dataId == 3){if(e.originalEvent.deltaY>0)return;$('html,body').scrollTop(0);}
  
  e.preventDefault();
  if (e.originalEvent.deltaY < 0) {
    $(this).slick('slickPrev');
  } else {
    $(this).slick('slickNext');
  }
}));
   function onSliderAfterChange2(event, slick, currentSlide) {
     $(event.target).data('current-slide', currentSlide);
    // console.log(currentSlide);
  }
    //video-play 
    $('.video-right-wrap .play-vid').on('click',function(){
        if($(this).attr('data-click') == 1) {
        $(this).attr('data-click', 0)
        $('#img-vid')[0].pause();
        $(".video-right-wrap .play-vid").css("opacity", "1");
        } else {
        $(this).attr('data-click', 1)
        $('#img-vid')[0].play();
        $(".video-right-wrap .play-vid").css("opacity", "1");
        $(".video-right-wrap .play-vid").css("opacity", "0");
        }
    });

    // currency
  function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });

// quickview
  $('body').on('click', '.quickview-close', function(e) {
    e.preventDefault();
    $('.quickview-popup').hide();
    $('body').removeClass('no-scroll quick-active');
  });
  
  $('body').on('click', '.quickview-btn, .show-qv', function(e) {
    e.preventDefault();
    $('body').addClass('no-scroll quick-active');
    var href= '/products/'+$(this).find('a').data('handle')+'?view=qv';
    $.get(href, function(product) {
      $('.quickview_popup_data').html(product);
      $('.qv_slider').slick({
          autoplay: false,
          slidesToShow: 1,
          speed: 1000,
          slidesToScroll: 1,
          arrows: true,
          prevArrow: '<button class="slide-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="4" height="6" viewBox="0 0 4 6" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.65976 0.662719C0.446746 0.879677 0.446746 1.23143 0.65976 1.44839L2.18316 3L0.65976 4.55161C0.446747 4.76856 0.446747 5.12032 0.65976 5.33728C0.872773 5.55424 1.21814 5.55424 1.43115 5.33728L3.34024 3.39284C3.55325 3.17588 3.55325 2.82412 3.34024 2.60716L1.43115 0.662719C1.21814 0.445761 0.872773 0.445761 0.65976 0.662719Z" fill="white"></path></svg></button>',
          nextArrow: '<button class="slide-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="4" height="6" viewBox="0 0 4 6" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.65976 0.662719C0.446746 0.879677 0.446746 1.23143 0.65976 1.44839L2.18316 3L0.65976 4.55161C0.446747 4.76856 0.446747 5.12032 0.65976 5.33728C0.872773 5.55424 1.21814 5.55424 1.43115 5.33728L3.34024 3.39284C3.55325 3.17588 3.55325 2.82412 3.34024 2.60716L1.43115 0.662719C1.21814 0.445761 0.872773 0.445761 0.65976 0.662719Z" fill="white"></path></svg></button>',
          dots: false,
          buttons: false,
          infinite: false,
          loop: false
      });

    });
    $('.quickview-popup').show();
  });

 $('body').on('change', '.nice-select.qv_select__select', function() {
    var selectedValues = [];

    // Collect selected option values
    $('.nice-select.qv_select__select').each(function() {
      var selectedValue = $(this).val();
      if (selectedValue) {
        selectedValues.push(selectedValue);
      }
    });
    var joinedValues = selectedValues.join(' / ');


    $('.variant-qv').each(function() {
     var variant_title = $(this).data('title'); 
     var variant_img = $('.variant-qv[data-title="'+variant_title+'"]').data('img');
     var variant_price = $('.variant-qv[data-title="'+variant_title+'"]').data('price');
     var qv_btn =  $('.variant-qv[data-title="'+variant_title+'"]').data('avail');
     var variant_id = $('.variant-qv[data-title="'+variant_title+'"]').data('id');
      variant_title = String(variant_title);
      joinedValues = String(joinedValues);
      
      if(variant_title === joinedValues){
      var slideIndex = $('.qv_slider .qv-pro-slider-img img[data-img="'+variant_img+'"]').parent().index();
      $('.qv_slider').slick('slickGoTo', slideIndex)
        
        $('.qv-price').find('.price-item--regular').text(variant_price);

        if(qv_btn === true ){
          $('#quick-view-temp .product-form__submit').find('span').text('Add to Cart');
          $('#quick-view-temp .product-form__submit').removeAttr('disabled');
          $('#quick-view-temp .quantity-select').show();
        }else{
          $('#quick-view-temp .product-form__submit').find('span').text('Sold out');
          $('#quick-view-temp .product-form__submit').attr('disabled', 'disabled');
          $('#quick-view-temp .quantity-select').hide();
        }

        $('input[name="id"]').val(variant_id);
        
      }
  });
  
  });
// end quickview
  
});  
if ($(".my-acc-column").length > 0) {
    jQuery(function ($) {
        var topMenuHeight = $("#daccount-nav").outerHeight();
        $("#account-nav").menuScroll(topMenuHeight);
        $(".account-list li:first-child").addClass("active");
    });
    // COPY THE FOLLOWING FUNCTION INTO ANY SCRIPTS
    jQuery.fn.extend({
        menuScroll: function (offset) {
            // Declare all global variables
            var topMenu = this;
            var topOffset = offset ? offset : 0;
            var menuItems = $(topMenu).find("a");
            var lastId;
            // Save all menu items into scrollItems array
            var scrollItems = $(menuItems).map(function () {
                var item = $($(this).attr("href"));
                if (item.length) {
                    return item;
                }
            });
            // When the menu item is clicked, get the #id from the href value, then scroll to the #id element
            $(topMenu).on("click", "a", function (e) {
                var href = $(this).attr("href");
                var offsetTop = href === "#" ? 0 : $(href).offset().top - topOffset;
                function checkWidth() {
                    var windowSize = $(window).width();
                    if (windowSize <= 767) {
                        $('html, body').stop().animate({
                            scrollTop: offsetTop - 200
                        }, 300);
                    }
                    else {
                        $('html, body').stop().animate({
                            scrollTop: offsetTop - 100
                        }, 300);
                    }
                }
                // Execute on load
                checkWidth();
                // Bind event listener
                $(window).resize(checkWidth);
                e.preventDefault();
            });
            // When page is scrolled
            $(window).scroll(function () {
                function checkWidth() {
                    var windowSize = $(window).width();
                    if (windowSize <= 767) {
                        var nm = $("html").scrollTop();
                        var nw = $("body").scrollTop();
                        var fromTop = (nm > nw ? nm : nw) + topOffset;
                        // When the page pass one #id section, return all passed sections to scrollItems and save them into new array current
                        var current = $(scrollItems).map(function () {
                            if ($(this).offset().top - 250 <= fromTop)
                                return this;
                        });
                        // Get the most recent passed section from current array
                        current = current[current.length - 1];
                        var id = current && current.length ? current[0].id : "";
                        if (lastId !== id) {
                            lastId = id;
                            // Set/remove active class
                            $(menuItems)
                                .parent().removeClass("active")
                                .end().filter("[href='#" + id + "']").parent().addClass("active");
                        }
                    }
                    else {
                        var nm = $("html").scrollTop();
                        var nw = $("body").scrollTop();
                        var fromTop = (nm > nw ? nm : nw) + topOffset;
                        // When the page pass one #id section, return all passed sections to scrollItems and save them into new array current
                        var current = $(scrollItems).map(function () {
                            if ($(this).offset().top <= fromTop)
                                return this;
                        });
                        // Get the most recent passed section from current array
                        current = current[current.length - 1];
                        var id = current && current.length ? current[0].id : "";
                        if (lastId !== id) {
                            lastId = id;
                            // Set/remove active class
                            $(menuItems)
                                .parent().removeClass("active")
                                .end().filter("[href='#" + id + "']").parent().addClass("active");
                        }
                    }
                }
                // Execute on load
                checkWidth();
                // Bind event listener
                $(window).resize(checkWidth);
            });
        }
    });
}
$(window).on('load resize orientationchange', function() { 
    /********* Wrapper top space ********/
    var header_hright = $('header').outerHeight();
    $('header').next('.wrapper').css('margin-top', header_hright + 'px');  
}); 
function responsiveMenu(){
  if(jQuery(window).width() < 768) {
    $('.product-filter-column').prependTo('.product-heading-row .container .row');
  }
  else { 
    $('.product-filter-column').prependTo('.product-list-row');
  }
}
jQuery(document).ready(function() {
  responsiveMenu();





  
});

jQuery(window).resize(function() {
  responsiveMenu();
});




 /////////// swiper js ////////////
 var swiper = new Swiper(".all-shoes-slider", {
      slidesPerView: 3,
      slidesPerGroup: 3,
      autoplay: false,
      speed: 1000,
      loop: true,
      a11y: false,
      navigation: {
        nextEl: ".swiper-button-next.best-arrow",
        prevEl: ".swiper-button-prev.best-arrow",
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
          slidesPerGroup: 3
        },
        481: {
          slidesPerView: 2,
          slidesPerGroup: 2
        },
        100: {
          slidesPerView: 1,
          slidesPerGroup: 1
        }
      },
    });  
    var swiper = new Swiper(".bestsell-slider", {
      slidesPerView: 2,
      slidesPerGroup: 2,
      autoplay: false,
      speed: 1000,
      loop: true,
      // a11y: false,
     observer: true,  
     observeParents: true,
      navigation: {
        nextEl: ".swiper-button-next.protab-arrow",
        prevEl: ".swiper-button-prev.protab-arrow",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2
        },
        100: {
          slidesPerView: 1,
          slidesPerGroup: 1
        }
      },
    }); 
    var swiper = new Swiper(".all-shes-second-slider", {
      slidesPerView: 4,
      slidesPerGroup: 4,
      autoplay: false,
      speed: 1000,
     loop: true,
      a11y: false,
      navigation: {
        nextEl: ".swiper-button-next.featured-arrow",
        prevEl: ".swiper-button-prev.featured-arrow",
      },
      breakpoints: {
        1200: {
          slidesPerView: 4,
          slidesPerGroup: 4
        },
        992: {
          slidesPerView: 3,
          slidesPerGroup: 3
        },
        592: {
          slidesPerView: 2,
          slidesPerGroup: 2
        },
        100: {
          slidesPerView: 1,
          slidesPerGroup: 1
        }
      },
    });
      var swiper = new Swiper(".testimonial-slider", {
      slidesPerView: 4,
      slidesPerGroup: 4,
      autoplay: false,
      speed: 1000,
     loop: true,
      a11y: false,
      navigation: {
        nextEl: ".swiper-button-next.testi-arrow",
        prevEl: ".swiper-button-prev.testi-arrow",
      },
      breakpoints: {
        1200: {
          slidesPerView: 4,
          slidesPerGroup: 4
        },
        992: {
          slidesPerView: 3,
          slidesPerGroup: 3
        },
        592: {
          slidesPerView: 2,
          slidesPerGroup: 2
        },
        100: {
          slidesPerView: 1,
          slidesPerGroup: 1
        }
      },
    });
    var swiper = new Swiper(".product-card-slider", {
      slidesPerView: 4,
      slidesPerGroup: 4,
      autoplay: false,
      speed: 1000,
      loop: true,
      a11y: false,
      navigation: {
        nextEl: ".swiper-button-next.category-arrow",
        prevEl: ".swiper-button-prev.category-arrow",
      },
      breakpoints: {
        1200: {
          slidesPerView: 4,
          slidesPerGroup: 4
        },
        992: {
          slidesPerView: 3,
          slidesPerGroup: 3
        },
        421: {
          slidesPerView: 2,
          slidesPerGroup: 2
        },
        100: {
          slidesPerView: 1,
          slidesPerGroup: 1
        }
      },
    });
      var swiper = new Swiper(".our-blogs-slider", {
      slidesPerView: 4,
        slidesPerGroup: 4,
      autoplay: true,
      speed: 1000,
     loop: true,
      a11y: false,
      navigation: {
        nextEl: ".swiper-button-next.blog-arrow",
        prevEl: ".swiper-button-prev.blog-arrow",
      },
      breakpoints: {
        1200: {
          slidesPerView: 4,
          slidesPerGroup: 4
        },
        992: {
          slidesPerView: 3,
          slidesPerGroup: 3
        },
        421: {
          slidesPerView: 2,
          slidesPerGroup: 2
        },
        100: {
          slidesPerView: 1,
          slidesPerGroup: 1
        }
      },
    });
      var swiper = new Swiper(".related-product-slider", {
      slidesPerView: 4,
      slidesPerGroup: 4,
      
      autoplay: true,
      speed: 2000,
      loop: true,
      a11y: false,
      navigation: {
        nextEl: ".swiper-button-next.related-arrow",
        prevEl: ".swiper-button-prev.related-arrow",
      },
      breakpoints: {
        1200: {
          slidesPerView: 4,
          slidesPerGroup: 4
        },
        992: {
          slidesPerView: 4,
          slidesPerGroup: 4
        },
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3
        },
        576: {
          slidesPerView: 2,
          slidesPerGroup: 2
        },
        100: {
          slidesPerView: 1,
          slidesPerGroup: 1
        }
      },
    });
    var swiper = new Swiper(".our-client-right", {
      slidesPerView: 5,
      slidesPerGroup: 5,
      autoplay: true,
      speed: 1000,
      loop: true,
      a11y: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        1200: {
          slidesPerView: 5,
          slidesPerGroup: 5
        },
        992: {
          slidesPerView: 4,
          slidesPerGroup: 4
        },
        576: {
          slidesPerView: 3,
          slidesPerGroup: 3
        },
        100: {
          slidesPerView: 1,
          slidesPerGroup: 1
        }
      },
    });
function countDownIni(countdown) {
  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
    } else if (countdown.attr('data-countdown')) {
      promoperiod = countdown.attr('data-countdown');
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass('countdown-block');
      countdown.countdown(promoperiod, function (event) {
        // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
        countdown.html(event.strftime('<span><span>%D</span><span class="dots"> : </span></span>' + '<span><span>%H</span><span class="dots"> : </span></span>' + '<span><span>%M</span><span class="dots"> : </span></span>' + '<span><span class="second">%S</span></span>'));
      });
    }

  });
  
}
function scrollFunctionDIV1() {
        let e = document.getElementById("shopNowDiv");
        e.scrollIntoView({
          block: 'start',
          behavior: 'smooth',
          inline: 'start'
        });
      }
function scrollFunctionDIV2() {
        let e = document.getElementById("customTabs");
        e.scrollIntoView({
          block: 'start',
          behavior: 'smooth',
          inline: 'start'
        });
      }
function openTab(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}
